import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/lang";
import axios from "axios";
import ElementUI from "element-ui";
import permission from "./directive/permission";
import pb from "./directive/permissionButton";
import vueWechatTitle from "vue-wechat-title";
import "./styles/index.scss";
import hasPermission from "@/directive/permissionButton/hasPermission";

const initVue = async () => {
  let platformInfo = await store.dispatch("platformStore/getPlatformInfo", {
    platform: "cds",
  });
  try {
    platformInfo = JSON.parse(platformInfo.value);
    // eslint-disable-next-line no-empty
  } catch (e) {}
  Vue.prototype.$setting = platformInfo || {};
  Vue.use(hasPermission);
  Vue.use(permission);
  Vue.use(pb);
  Vue.config.productionTip = false;
  Vue.prototype.$http = axios;
  Vue.use(ElementUI, { size: "small" });
  Vue.use(vueWechatTitle);
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
};

initVue();
